import { MenuItem } from '@card-software/library';
import {
  DyeingRoles,
  DyehouseDailyMetricRoles,
  FinishingRoles,
  KnittingOrderRoles,
  MachineAssignmentRoles,
  MachineDashboardRoles,
  ProductionBatchRoles,
  ProductionCardRoles,
  ProductionReportsRoles,
  DailyProductionProcessRoles,
  ProductionDetailProcessRoles,
  ProductionWorkOrderRoles,
  ReprocessOrdersRoles,
  StationsRoles,
} from './models/roles/roles-group';

export const MENU_ITEMS: MenuItem[] = [
  {
    displayName: 'Main',
    routerLink: '',
    redirect: false,
    children: [
      {
        displayName: 'Production',
        routerLink: '/main/dashboard-production-cards',
        redirect: true,
      },
      {
        displayName: 'Machine Assignment',
        routerLink: '/main/machine-assignment',
        redirect: true,
        roles: [MachineAssignmentRoles.MachineAssignmentViewer, MachineAssignmentRoles.MachineAssignmentAdmin],
      },
      {
        displayName: 'Daily Consumptions',
        routerLink: '/main/daily-consumptions',
        redirect: true,
        roles: [DyehouseDailyMetricRoles.DyehouseDailyMetricViewer, DyehouseDailyMetricRoles.DyehouseDailyMetricAdmin],
      },
    ],
  },
  {
    displayName: 'Reprocess',
    routerLink: '',
    redirect: false,
    children: [
      {
        displayName: 'Reprocess PCs',
        routerLink: '/reprocess',
        redirect: true,
        roles: [ReprocessOrdersRoles.ReprocessOrdersAdmin],
      },
    ],
  },
  {
    displayName: 'Planning',
    routerLink: '',
    redirect: false,
    children: [
      {
        displayName: 'Production Cards',
        routerLink: '/work-orders-for-production-cards',
        redirect: true,
        roles: [ProductionCardRoles.ProductionCardsEditor, ProductionCardRoles.ProductionCardsViewer],
      },
      {
        displayName: 'Knitting Order',
        routerLink: '/knitting-orders',
        redirect: true,
        roles: [KnittingOrderRoles.KnittingOrderAllEditor, KnittingOrderRoles.KnittingOrderViewer],
      },
      {
        displayName: 'Knitting Yarn Balance',
        routerLink: '/knitting-order-yarn-balance',
        redirect: true,
      },
      {
        displayName: 'Batches',
        routerLink: '/batches',
        redirect: true,
        roles: [ProductionBatchRoles.ProductionBatchEditor, ProductionBatchRoles.ProductionBatchViewer],
      },
    ],
  },
  {
    displayName: 'Production',
    routerLink: '',
    redirect: false,
    children: [
      {
        displayName: 'Production Work Orders',
        routerLink: '/production-work-orders',
        redirect: true,
        roles: [ProductionWorkOrderRoles.ProductionWorkOrderEditor, ProductionWorkOrderRoles.ProductionWorkOrderViewer],
      },
    ],
  },
  {
    displayName: 'Knitting',
    routerLink: '',
    redirect: false,
    children: [
      {
        displayName: 'Machine Dashboard',
        routerLink: '/stations/knitting-dashboard',
        redirect: true,
        roles: [MachineDashboardRoles.MachineDashboardViewer, MachineDashboardRoles.MachineDashboardEditor],
      },
      {
        displayName: 'Stations',
        routerLink: '/stations',
        redirect: true,
        roles: [StationsRoles.WeightStationsEditor, StationsRoles.WeightStationsViewer],
      },
      {
        displayName: 'Shifts',
        routerLink: '/shifts',
        redirect: true,
      },
      {
        displayName: 'Roll Split',
        routerLink: '/roll-split',
        redirect: true,
      },
      {
        displayName: 'Reassign Rolls',
        routerLink: '/reassign-rolls',
        redirect: true,
        roles: [ProductionCardRoles.ProductionCardsEditor, ProductionCardRoles.ProductionCardsViewer],
      },
    ],
  },
  {
    displayName: 'Dyeing',
    roles: [DyeingRoles.DyeingViewer, DyeingRoles.DyeingAdmin],
    routerLink: '',
    redirect: false,
    children: [
      {
        displayName: 'Dashboard',
        routerLink: 'dyeing/dashboard',
        redirect: true,
      },
    ],
  },
  {
    displayName: 'Finishing',
    roles: [FinishingRoles.FinishingViewer, FinishingRoles.FinishingAdmin],
    routerLink: '',
    redirect: false,
    children: [
      {
        displayName: 'Stations Dashboard',
        routerLink: 'finishing/dashboard',
        redirect: true,
      },
      {
        displayName: 'Lab Testing',
        routerLink: 'finishing/laboratory-tests',
        redirect: true,
      },
      {
        displayName: 'Roll Final QC',
        routerLink: 'finishing/roll-final-qc',
        redirect: true,
      },
    ],
  },
  {
    displayName: 'Reporting',
    routerLink: '',
    redirect: false,
    children: [
      {
        displayName: 'Production Reports',
        routerLink: '/reporting',
        redirect: true,
        roles: [
          ProductionReportsRoles.ProductionReportsViewer,
          ProductionReportsRoles.ProductionReportsAdmin,
          ...Object.values(DailyProductionProcessRoles),
          ...Object.values(ProductionDetailProcessRoles),
        ],
      },
    ],
  },
];
